import React from 'react';
//import s from './Message.module.css';

const Messages = (props) => {
    return (
        <div>
            {props.message}
        </div>
    )
}

export default Messages;